import { render, staticRenderFns } from "./SalesReportDetail.vue?vue&type=template&id=f21d7f74"
import script from "./SalesReportDetail.vue?vue&type=script&lang=js"
export * from "./SalesReportDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports